import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw } from 'lucide-react';
import { Button } from '@ridemaadi/ui';

/** Shows a refresh toast when a new service-worker build is ready. */
export function UpdateToast() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div className="fixed inset-x-3 top-16 z-50 flex items-center gap-3 rounded-xl border border-border bg-surface p-3 shadow-lg">
      <RefreshCw className="h-5 w-5 shrink-0 text-accent" />
      <p className="flex-1 text-sm">A new version is available.</p>
      <Button size="sm" onClick={() => updateServiceWorker(true)}>
        Reload
      </Button>
      <Button size="sm" variant="ghost" onClick={() => setNeedRefresh(false)}>
        Later
      </Button>
    </div>
  );
}
